import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="module-global--formdata" id="module-global--formdata"></a>
    <h1 {...{
      "id": "windowformdata"
    }}>{`window.FormData`}</h1>
    <a name="new-module-global--formdata-new" id="new-module-global--formdata-new"></a>
    <h2 {...{
      "id": "formdata"
    }}>{`FormData()`}</h2>
    <p>{`FormData provides a way to construct a set of key/value pairs, which can be used in fetch(), XMLHttpRequest.`}</p>
    <a name="module-global--formdata-append" id="module-global--formdata-append"></a>
    <h2 {...{
      "id": "appendname-value-filename"
    }}>{`append(name, value, fileName)`}</h2>
    <p>{`Appends a key value pair into FormData.
If the value is either ArrayBuffer and TypedArray, its buffer as well as the object are copied.
However, if the value is a File object value, the File object is cloned but its content is not cloned.
Consequently, the File object and the cloned one refer to the same content.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/FormData/append"
      }}>{`FormData - append`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Key string for the pair`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`ArrayBuffer`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`TypedArray`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`File`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Blob`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Value for the pair`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`fileName`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`'Optional' file name to use for a File or a Blob object value. The default filename is "blob" for Blob object and the file name would be taken from the name property for File object.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="module-global--formdata-delete" id="module-global--formdata-delete"></a>
    <h2 {...{
      "id": "deletename"
    }}>{`delete(name)`}</h2>
    <p>{`Removes all entries from FormData whose name is same with the input name.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/FormData/delete"
      }}>{`FormData - delete`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the key to delete`}</td>
        </tr>
      </tbody>
    </table>
    <a name="module-global--formdata-entries" id="module-global--formdata-entries"></a>
    <h2 {...{
      "id": "entries"
    }}>{`entries()`}</h2>
    <p>{`Returns an iterator which iterates through all key/value pairs contained in the FormData.
The key of each pair is a string object and the value is either a string or a Blob object.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`iterator`}</inlineCode>{` - Iterator for all key-value pairs in FormData.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/FormData/entries"
      }}>{`FormData - entries`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <a name="module-global--formdata-get" id="module-global--formdata-get"></a>
    <h2 {...{
      "id": "getname"
    }}>{`get(name)`}</h2>
    <p>{`Returns the first value associated with a given key from within a FormData object.
Use getAll() if you expect multiple values and want all of them.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`Blob`}</inlineCode>{` - Value whose key matches the specified name. Otherwise, null.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/FormData/get"
      }}>{`FormData - get`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the key to retrieve`}</td>
        </tr>
      </tbody>
    </table>
    <a name="module-global--formdata-getall" id="module-global--formdata-getall"></a>
    <h2 {...{
      "id": "getallname"
    }}>{`getAll(name)`}</h2>
    <p>{`Returns all the values associated with a given key from within a FormData object.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Array`}</inlineCode>{` - Array of values whose key matches the specified name. Otherwise, an empty list.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/FormData/getAll"
      }}>{`FormData - getAll`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the key to retrieve`}</td>
        </tr>
      </tbody>
    </table>
    <a name="module-global--formdata-has" id="module-global--formdata-has"></a>
    <h2 {...{
      "id": "hasname"
    }}>{`has(name)`}</h2>
    <p>{`Test if a FormData object contains a certain key.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{` - True if a key of FormData matches the specified name. Otherwise, false.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/FormData/has"
      }}>{`FormData - has`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the key to test`}</td>
        </tr>
      </tbody>
    </table>
    <a name="module-global--formdata-keys" id="module-global--formdata-keys"></a>
    <h2 {...{
      "id": "keys"
    }}>{`keys()`}</h2>
    <p>{`Returns an iterator which iterates through all keys in FormData.
The keys are strings.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`iterator`}</inlineCode>{` - Iterator of FormData's keys.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/FormData/keys"
      }}>{`FormData - keys`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <a name="module-global--formdata-set" id="module-global--formdata-set"></a>
    <h2 {...{
      "id": "setname-value-filename"
    }}>{`set(name, value, filename)`}</h2>
    <p>{`If there are entries whose name is same with the input name,
replaces the first existing entry with new entry and removes the others.
If not, appends a new entry with name/value.`}</p>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/FormData/set"
      }}>{`FormData - set`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Name of the field`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`Blob`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Field's value. The value is converted to a string if the value is neither string nor Blob.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`filename`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filename reported to the server when a Blob object or a File object is passed as a value.      The default filename is "blob" for Blob object and the file name would be taken from the name property for File object.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="module-global--formdata-values" id="module-global--formdata-values"></a>
    <h2 {...{
      "id": "values"
    }}>{`values()`}</h2>
    <p>{`Returns an iterator which iterates through all values in the FormData.
The values are strings or Blob objects.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`iterator`}</inlineCode>{` - Iterator of FormData's values.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/FormData/values"
      }}>{`FormData - values`}</a><br parentName="p"></br>{`
`}<strong parentName="p">{`Since`}</strong>{`: v7.3.0  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      